
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirece37"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirece37"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $bd37264496907ef9$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.2ceba3f0.js","3hXGM","sprite.e39833fe.svg"]'));

const $ba30e20475feac5a$export$966699b7edd92bb3 = {
    method: "GET",
    headers: {
        "X-RapidAPI-Key": "9784e9059dmsh5554ae325dc1592p180343jsn0821abf68f76",
        "X-RapidAPI-Host": "hotels-com-provider.p.rapidapi.com"
    }
};
const $ba30e20475feac5a$export$a9861bd62f48e142 = "84c36219a76b42c5a389a19e2f2602d2";
const $ba30e20475feac5a$export$5feaddb1377b7f5e = 5;


var $c6dce984b44c99a5$exports = {};
$c6dce984b44c99a5$exports = new URL("sprite.e39833fe.svg", import.meta.url).toString();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _data;
    /**
   * Renderizando o objeto recebido para o DOM
   * @param {Object | Object[]} data  O dado para ser renderizado
   * @param {boolean} [render=true] se falso, cria um markup string ao invés de ser renderizado no DOM
   * @returns {undefined | String} Ira retornar uma marção se render=false
   * @this {Object} View instance
   * @author Matheus
   */ render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    /**
   * @param {Object} data Atualiza uma nova marcação dos dados recebidos para o DOM
   * @returns {String} Ira retonar uma nova marcação dos dados para ser renderizado no DOM
   */ update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // Update changed TEXT
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            // Update changed ATTRIBUTES
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attri)=>curEl.setAttribute(attri.name, attri.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    renderMessage(message = this._successMessage) {
        const markup = `
      <div class="message">
        <svg class="message__icon">
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports)))}#icon-location_city"></use>
        </svg>
        <p>${message}</p>
      </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(message = this._errorMessage) {
        const markup = `
      <div class="error">
        <svg class="error__icon">
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports)))}#icon-warning"></use>
        </svg>
        <p>${message}</p>
    </div>
  `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderSpinner() {
        const markup = `
        <div class="loading">
            <svg class="loading__icon">
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports)))}#icon-spinner"></use>
            </svg>
        </div>
        `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}





class $5009736560ba46f6$var$PreviewHotel extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
    <div class="hotel-preview__block 
    ${this._data.hotelId === id ? "hotel-preview__block--active" : ""}">
        <div class="hotel-preview__gallery">
            <img src="${this._data.imageUrl}" 
            class="hotel-preview__gallery-photo" alt="image of 
            ${this._data.imageDescription}">
        </div>
     
        <div class="informations">
            <div class="informations__header">
                <h1 class="informations__header-title">
                    <a class="informations__header-link" href="#${this._data.hotelId}">
                    ${this._data.nameHotel}</a>
                </h1>
    
                <div class="informations__location">
                    <svg class="informations__icon-location">
                        <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-location-pin"></use>
                    </svg>
                    <span class="informations__location-city">
                    ${this._data.local}</span>
                </div>
            </div>
    
            <div class="informations__price">
                <span class="informations__price-value">
                ${this._data.symbol + this._data.price}</span>
            </div>
    
            <div class="informations__avaliation">
                <div class="informations__rating">
                    <div class="informations__rating-average">
                    ${this._data.reviewScore}</div>
                    <div class="informations__rating-count">
                    ${this._data.reviewTotal} votes</div>
                </div>
            </div>
        </div>
        </div>
        `;
    }
}
var $5009736560ba46f6$export$2e2bcd8739ae039 = new $5009736560ba46f6$var$PreviewHotel();


class $399165a28688804c$var$RenderPreview extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".hotel-preview");
    _errorMessage = "N\xe3o foi poss\xedvel achar nenhum hotel. Tente novamente por favor!";
    handlerClick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".informations__header-title");
            if (!btn) return;
            // Filtra o id do hotel com base em seu nome e manda para a URL
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.map((data)=>data).filter((data)=>{
                if (data.nameHotel === btn.innerText) return $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel = data;
                location.hash = $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.hotelId;
            });
            handler();
        });
    }
    _generateMarkup() {
        return this._data.map((result)=>(0, $5009736560ba46f6$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $399165a28688804c$export$2e2bcd8739ae039 = new $399165a28688804c$var$RenderPreview();


"use stric";
/**
 * @param {object} SearchHotel Faz toda busca do hotel
 */ class $9f84bbaa968b2f26$var$SearchHotel {
    _id;
    _domain;
    _checkinInput = document.getElementById("checkin");
    _checkoutInput = document.getElementById("checkout");
    _adultInput = document.getElementById("adult");
    _childrenInput = document.getElementById("child");
    _locale = navigator.language.replace("-", "_");
    btnSearch = document.querySelector(".search__button");
    getQuery() {
        const query = document.querySelector(".search__input").value;
        return query;
    }
    handlerClick(handler) {
        this.btnSearch.addEventListener("click", handler);
    }
    /**
   * @param {object} getCityInput Recebe o nome da cidade e pega o código do país (e.g. BR)
   */ async getCityInput(text) {
        try {
            const response = await fetch(`https://api.geoapify.com/v1/geocode/search?text=${text}&format=json&apiKey=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
            const result = await response.json();
            const city = await result.results[0].city;
            const countryCode = await result.results[0].country_code;
            const domain = countryCode.toUpperCase();
            this._domain = domain;
            return this.getCityName(city);
        } catch (err) {
            throw err;
        }
    }
    /**
   * @param {object} getCityName Recebe o nome da cidade o código do país para fazer a buca de hóteis
   */ async getCityName(city) {
        try {
            const response = await fetch(`https://hotels-com-provider.p.rapidapi.com/v2/regions?query=${city}&domain=${this._domain}&locale=${this._locale}`, (0, $ba30e20475feac5a$export$966699b7edd92bb3));
            const result = await response.json();
            const getId = await result.data[0].essId.sourceId;
            this._id = getId;
            return getId;
        } catch (err) {
            throw err;
        }
    }
    /**
   * @param {object} getHotel Pega o hotel com base no dados fornecidados de getCityName
   */ async getHotel() {
        try {
            if (!this._childrenInput.value) this._childrenInput.value = 0;
            const url = `https://hotels-com-provider.p.rapidapi.com/v2/hotels/search?region_id=${this._id}&locale=${this._locale}&checkin_date=${this._checkinInput.value}&sort_order=RECOMMENDED&adults_number=${this._adultInput.value}&domain=${this._domain}&checkout_date=${this._checkoutInput.value}&children_ages=${this._childrenInput.value}`;
            const response = await fetch(url, (0, $ba30e20475feac5a$export$966699b7edd92bb3));
            if (!response.ok) throw (0, $399165a28688804c$export$2e2bcd8739ae039).renderError();
            const result = await response.json();
            return result;
        } catch (err) {
            throw err;
        }
    }
    /**
   * @return Retorna detalhes do importantes para a renderização do hotel
   */ async hotelDetails() {
        try {
            const id = location.hash.slice(1);
            if (!id || !this._domain) return;
            const url = `https://hotels-com-provider.p.rapidapi.com/v2/hotels/details?domain=${this._domain}&hotel_id=${id}&locale=${this._locale}`;
            const data = await fetch(url, (0, $ba30e20475feac5a$export$966699b7edd92bb3));
            if (!data.ok) throw new Error();
            const result = await data.json();
            return result;
        } catch (error) {
            throw error;
        }
    }
    /**
   * @returns Retorna as avaliações do hotel feita pelos hóspedes
   */ async hotelReviews() {
        try {
            const id = location.hash.slice(1);
            if (!id || !this._domain) return;
            const url = `https://hotels-com-provider.p.rapidapi.com/v2/hotels/reviews/list?domain=${this._domain}&locale=${this._locale}&hotel_id=${id}`;
            const data = await fetch(url, (0, $ba30e20475feac5a$export$966699b7edd92bb3));
            if (!data.ok) throw new Error();
            const result = await data.json();
            return result;
        } catch (error) {
            throw error;
        }
    }
}
var $9f84bbaa968b2f26$export$2e2bcd8739ae039 = new $9f84bbaa968b2f26$var$SearchHotel();





class $d705f7327231b19e$var$FavoriteView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".favorites__list");
    _errorMessage = "Sem hoteis por aqui. Ache um hotel legal :)";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((favorite)=>(0, $5009736560ba46f6$export$2e2bcd8739ae039).render(favorite, false)).join("");
    }
}
var $d705f7327231b19e$export$2e2bcd8739ae039 = new $d705f7327231b19e$var$FavoriteView();


"use strict";
const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    hotel: {},
    favorites: [],
    search: {
        results: [],
        page: 1,
        perPage: (0, $ba30e20475feac5a$export$5feaddb1377b7f5e)
    },
    detailsHotel: {},
    reviews: {}
};
const $0f1d4402dffacf5b$export$1ba1baf75bde44b1 = async function() {
    try {
        const details = await (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).getHotel();
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = details.properties.map((value)=>{
            return {
                hotelId: value.id,
                roomsLeft: value.availability?.minRoomsLeft,
                imageUrl: value.propertyImage.image.url,
                imageDescription: value.propertyImage.image.description,
                nameHotel: value.name,
                reviewScore: value.reviews.score,
                reviewTotal: value.reviews.total,
                local: value.neighborhood?.name,
                symbol: value.price.lead.currencyInfo.symbol,
                price: Math.round(value.price.lead.amount)
            };
        });
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$cfcc0908d6dfb8a6 = function(page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.perPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.perPage;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f1d4402dffacf5b$export$e69ff5f1472b9baa = async function() {
    try {
        const data = await (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).hotelDetails();
        if (!data) return;
        const img = data.propertyGallery.images.slice(0, 3).map((img)=>img.image.url);
        const ameni = data.summary.amenities.topAmenities.items.map((amenity)=>amenity.text);
        const icon = Math.floor(data.summary.overview.propertyRating.rating);
        const description = {
            images: img,
            amenities: ameni,
            description: data.summary.location.whatsAround.editorial.content[0],
            address: data.summary.location.address.city,
            icon: icon
        };
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.detailsHotel = description;
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$cf31305e89293b23 = async function() {
    try {
        const data = await (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).hotelReviews();
        if (!data) return;
        const score = data.reviewInfo.reviews.slice(0, 2).map((score)=>{
            const value = score.reviewScoreWithDescription.value;
            const scoreValue = value.split("-").slice(0, 1).join("\n");
            return scoreValue;
        });
        const reviewName = data.reviewInfo.reviews.slice(0, 2).map((duration)=>{
            const data = duration.stayDuration;
            const nameReview = data.split(",").slice(0, -1).join("\n");
            return nameReview;
        });
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.reviews = data.reviewInfo.reviews.slice(0, 2).map((value)=>{
            return {
                score: score,
                reviewInfo: value.text,
                name: reviewName,
                stayDuration: value.submissionTimeLocalized
            };
        });
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$f3b5b64d78ef0e9e = function(id) {
    try {
        // Se verdadeiro marca o hotel atual como favoritado
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites.some((favorite)=>favorite.hotelId === id)) $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.favorite = true;
        else $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.favorite = false;
    } catch (error) {
        (0, $d705f7327231b19e$export$2e2bcd8739ae039).renderError();
    }
};
const $0f1d4402dffacf5b$var$setFavorites = function() {
    localStorage.setItem("favorites", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites));
};
const $0f1d4402dffacf5b$export$aa03d8c0f74def9f = function(hotel) {
    //add ffavorito
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites.push(hotel);
    // Marque o hotel atual como favorito
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.favorite = true;
    $0f1d4402dffacf5b$var$setFavorites();
};
const $0f1d4402dffacf5b$export$136048bcb9946c75 = function(id) {
    // Deleta o hotel atual
    const index = $0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites.findIndex((el)=>el.hotelId === id);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites.splice(index, 1);
    // Deleta o hotel atual como favorito
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.favorite = false;
    $0f1d4402dffacf5b$var$setFavorites();
};
const $0f1d4402dffacf5b$var$init = function() {
    const storage = localStorage.getItem("favorites");
    if (storage) $0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites = JSON.parse(storage);
};
$0f1d4402dffacf5b$var$init();





class $cfa940594ee109f7$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    addHandler(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn-change");
            if (!btn) return;
            const goTo = +btn.dataset.goto;
            handler(goTo);
        });
    }
    _generateMarkup() {
        const currentPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / +this._data.perPage);
        if (currentPage === 1 && numPages > 1) return this._generateMarkupBtn("next", currentPage);
        if (currentPage === numPages && numPages > 1) return this._generateMarkupBtn("prev", currentPage);
        if (currentPage < numPages) return `
    ${this._generateMarkupBtn("prev", currentPage)}
    ${this._generateMarkupBtn("next", currentPage)}`;
        return "";
    }
    _generateMarkupBtn(type, currentPage) {
        return type === "next" ? `
        <button data-goto="${currentPage + 1}" class="btn-change next">
          <span>Page ${currentPage + 1}</span>
            <svg class="pagination__arrow ">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-arrow-right"></use>
            </svg>
        </button>
    ` : `
          <button data-goto="${currentPage - 1}" class="btn-change prev">
            <span>Page ${currentPage - 1}</span>
              <svg class="pagination__arrow ">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-arrow-left"></use>
              </svg>
          </button>
    `;
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView();






class $3b1e9f66478ed086$var$HotelView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".hotel-view");
    _errorMessage = "N\xe3o foi possivel achar o hotel desejado :(";
    addHandlerAddFavorite(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn-favorite");
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
            <div class="gallery">
                ${this._data.detailsHotel.images.map((img)=>{
            return `
                        <figure class="gallery__item">
                            <img src="${img}" alt="Photo of hotel" class="gallery__photo">
                        </figure>`;
        })}

                <button class="gallery__btn-favorite btn-favorite">
                    <svg class="gallery__icon  gallery__icon--favorite">
                        <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-favorite${this._data.hotel.favorite ? "_fill" : ""}">
                        </use>
                    </svg>
                </button>

            </div>
            <div class="overview">
                    <h1 class="overview__heading">
                        ${this._data.hotel.nameHotel}
                    </h1>
                <div class="overview__stars">
                    ${this.generateIcon()}
                </div>
                <div class="overview__location">
                    <svg class="overview__icon-location">
                        <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-location-pin"></use>
                    </svg>
                    <button class="btn-inline">
                    ${this._data.hotel.local},${this._data.detailsHotel.address}
                    </button>
                </div>
                <div class="overview__rating">
                    <div class="overview__rating-average">
                    ${this._data.hotel.reviewScore}</div>
                    <div class="overview__rating-count">
                    ${this._data.hotel.reviewTotal} votes</div>
                </div>
            </div>
            <div class="detail">
            <div class="description">
                <p class="paragraph">
                    ${this._data.detailsHotel.description}
                </p>
                <ul class="list">
                    ${this._data.detailsHotel.amenities.map((ameni)=>{
            return `
                            <li class="list__item">${ameni}</li>
                        `;
        }).join("")}
                </ul>
            </div>
            <div class="user-reviews">

                <figure class="review">
                    <blockquote class="review__text">
                        ${this._data.reviews[0].reviewInfo}
                    </blockquote>
                    <figcaption class="review__user">
                        <svg class="review__photo">
                            <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-person"></use>
                        </svg>
                        <div class="review__user-box">
                            <p class="review__user-name">
                            ${this._data.reviews[0].name[0]}</p>
                            <p class="review__user-date">
                            ${this._data.reviews[0].stayDuration}</p>
                        </div>
                        <div class="review__rating">
                        ${this._data.reviews[0].score[0]}</div>
                    </figcaption>
                </figure>

                <figure class="review">
                    <blockquote class="review__text">
                        ${this._data.reviews[1].reviewInfo}
                    </blockquote>
                    <figcaption class="review__user">
                        <svg class="review__photo">
                            <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-person"></use>
                        </svg>
                        <div class="review__user-box">
                            <p class="review__user-name">
                            ${this._data.reviews[1].name[1]}</p>
                            <p class="review__user-date">
                            ${this._data.reviews[1].stayDuration}</p>
                        </div>
                        <div class="review__rating">
                        ${this._data.reviews[1].score[1]}</div>
                    </figcaption>
                </figure>
            </div>
        </div>
        <div class="cta">
        ${this._data.hotel.roomsLeft > 0 ? `
        <h2 class="cta__book-now">
            Good news! We have ${this._data.hotel.roomsLeft} free rooms for your selected dates!
        </h2>
        <button class="btn">
            <span class="btn__visible">Book now</span>
            <span class="btn__invisible">Only ${this._data.hotel.roomsLeft} rooms left</span>
        </button>
        ` : `
        <h2 class="cta__book-now">
            Bad news! We dont't have free rooms for your selected dates!
        </h2>   
        `}
        </div>`;
    }
    generateIcon() {
        if (this._data.detailsHotel.icon === 0 || this._data.detailsHotel.icon === "") return "Sem m\xe9dia de avalia\xe7\xf5es.";
        // Controla quantas estrelas o hotel tem ou não
        switch(this._data.detailsHotel.icon){
            case 1:
                return `
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              `;
            case 2:
                return `
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              `;
            case 3:
                return `
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              `;
            case 4:
                return `
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              `;
            case 5:
                return `
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              <svg class="overview__icon-star">
                  <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($c6dce984b44c99a5$exports))}#icon-star"></use>
              </svg>
              `;
            default:
                return;
        }
    }
}
var $3b1e9f66478ed086$export$2e2bcd8739ae039 = new $3b1e9f66478ed086$var$HotelView();


class $b0bb4f2c32873207$var$RenderView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".hotel-view");
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    _generateMarkup() {
        return (0, $3b1e9f66478ed086$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e, false);
    }
}
var $b0bb4f2c32873207$export$2e2bcd8739ae039 = new $b0bb4f2c32873207$var$RenderView();





"use stric";
const $f50bd1f2915ed0f2$var$controlSearchResults = async function() {
    try {
        (0, $399165a28688804c$export$2e2bcd8739ae039).renderSpinner();
        // Pega a cidade do input
        const city = (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).getQuery();
        if (!city) throw new Error();
        // Passa a cidade para o objeto
        await (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).getCityInput(city);
        // Pega os dados e manda para o state Object
        await $0f1d4402dffacf5b$export$1ba1baf75bde44b1();
        // Renderiza a preview na página de busca
        (0, $399165a28688804c$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$cfcc0908d6dfb8a6(1));
        // Renderiza os botões para a paginação
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    } catch (error) {
        (0, $399165a28688804c$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$controlPaginiation = function(goTo) {
    (0, $399165a28688804c$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$cfcc0908d6dfb8a6(goTo));
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
//Pega dados nescessários para a renderização do hotel
const $f50bd1f2915ed0f2$var$controlDetails = async function() {
    try {
        await $0f1d4402dffacf5b$export$e69ff5f1472b9baa();
        await $0f1d4402dffacf5b$export$cf31305e89293b23();
    } catch (error) {
        throw error;
    }
};
// Controla a View quando o título ou a hash da URL tiver alteração
const $f50bd1f2915ed0f2$var$controlView = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $b0bb4f2c32873207$export$2e2bcd8739ae039).renderSpinner();
        $0f1d4402dffacf5b$export$f3b5b64d78ef0e9e(id);
        await $f50bd1f2915ed0f2$var$controlDetails();
        (0, $3b1e9f66478ed086$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    } catch (error) {
        (0, $3b1e9f66478ed086$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$controlAddFavorite = function() {
    // Se falso ira add o hotel atual nos favoritos do usúario
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.favorite) $0f1d4402dffacf5b$export$aa03d8c0f74def9f($0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel);
    else $0f1d4402dffacf5b$export$136048bcb9946c75($0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel.hotelId);
    // Ira atualizar a View do hotel conforme adicionado ou deletado o hotel dos favoritos
    (0, $b0bb4f2c32873207$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.hotel);
    // Ira atualizar a View dos favoritos para renderizar a preview do hotel
    (0, $d705f7327231b19e$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites);
};
const $f50bd1f2915ed0f2$var$controlFavorite = function() {
    (0, $d705f7327231b19e$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.favorites);
};
const $f50bd1f2915ed0f2$var$init = async function() {
    (0, $d705f7327231b19e$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlFavorite);
    (0, $9f84bbaa968b2f26$export$2e2bcd8739ae039).handlerClick($f50bd1f2915ed0f2$var$controlSearchResults);
    (0, $399165a28688804c$export$2e2bcd8739ae039).handlerClick($f50bd1f2915ed0f2$var$controlView);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addHandler($f50bd1f2915ed0f2$var$controlPaginiation);
    (0, $3b1e9f66478ed086$export$2e2bcd8739ae039).addHandlerAddFavorite($f50bd1f2915ed0f2$var$controlAddFavorite);
    (0, $b0bb4f2c32873207$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlView);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.2ceba3f0.js.map
